import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

export const styles = {};

export const overrides = {
	'.event-detail-page': {
		paddingBottom: remCalc(160),
		'.eventsDetail__recurring_event_container': {
			marginTop: remCalc(80),
			'.eventsDetail__recurring_event_grid': {
				// display: 'flex',
				// flexDirection: 'row',
				// gap: remCalc(40),
				// alignItems: 'center',
				// justifyContent: 'flex-start',
				// flexWrap: 'wrap',
				paddingTop: remCalc(40),
				'.eventsDetail__recurring_event': {
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					padding: `${remCalc(20)} ${remCalc(40)}`,
					background: getColor('white', 100),
					boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
					backdropFilter: 'blur(15px)',
					gap: remCalc(6),
					border: `1px solid ${getColor('white', 100)}`,
					'.eventsDetail__recurring_event__day': {

					},
					'.eventsDetail__recurring_event__date': {
						
					},
					'.eventsDetail__recurring_event__time': {
						
					},
					'&.active': {
						borderColor: getColor('ivory', 800),
					},
					'@media (hover: hover) and (pointer: fine)': {
						'&:not(.active)': {
							'&:hover': {
								cursor: 'pointer'
							}
						}
					}
				}
			}
		}
	}
};

export default styles;